import { buildFacetDesignOverrideLite, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverrideLite';
import {
  FDHeadlineText, FDSelectInput,
} from '@facet-wealth/design';

import { Disclosure } from 'Views/FreemiumEntry/HasRelationship/Content/Components/Disclosure';


const fqResponseContactAndQualificationInformationRefereeMetaOverrideSet = buildFacetDesignOverrideLite()
  .nameOverride('contactInfoTitle', {
    _component: () => FDHeadlineText,
    _customProps: {
      size: 'lg',
      color: 'textSecondary',
      align: 'center',
    },
  }, overrideReadOnly)
  .nameOverride(['disclosure', 'generalDisclosure', 'formDisclosure'], {
    _component: () => Disclosure,
    _customProps: {
      align: 'center',
    },
  }, overrideReadOnly)
  .nameOverride(['householdIncome', 'estimatedSavings'], {
    _component: () => FDSelectInput,
    _customProps: { helperText: '' },
  }, overrideReadOnly);

export { fqResponseContactAndQualificationInformationRefereeMetaOverrideSet };
